import { showToast } from '@lokalise/louis';
import type { Middleware, MiddlewareAPI } from '@reduxjs/toolkit';
import { isRejectedWithValue } from '@reduxjs/toolkit';

import contentEngineApi from './content-engine';
import identityApi from './identity';

export const contentEngineErrorHandlerLogger: Middleware = (api: MiddlewareAPI) => (next) => (action) => {
    if (action.type.startsWith(contentEngineApi.reducerPath) && isRejectedWithValue(action)) {
        showToast({
            type: 'error',
            title: 'Connection issue',
            description: 'You can refresh the page and try again.',
        });
    }

    return next(action);
};

export default [contentEngineApi.middleware, contentEngineErrorHandlerLogger, identityApi.middleware];
